var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11043",
    "data-name": "Group 11043",
    transform: "translate(23652 19915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(-23652 -19915)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528",
    transform: "translate(-23647.5 -19909.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478",
    transform: "translate(0.726 16.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M41.936,419.169a.726.726,0,0,0-.726.726v.726h7.256v-.726a.726.726,0,0,0-.726-.726Z",
    transform: "translate(-41.21 -419.169)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(5.805 0.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M165.03,419.169h-1.088a.726.726,0,0,1,.726.726v.726h1.088v-.726A.726.726,0,0,0,165.03,419.169Z",
    transform: "translate(-163.942 -419.169)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M43.024,419.169H41.936a.726.726,0,0,0-.726.726v.726H42.3v-.726A.726.726,0,0,1,43.024,419.169Z",
    transform: "translate(-41.21 -419.169)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M40.644,413.164H33.388a.363.363,0,0,1-.363-.363v-.726a1.09,1.09,0,0,1,1.088-1.088h5.8a1.09,1.09,0,0,1,1.088,1.088v.726A.363.363,0,0,1,40.644,413.164Zm-6.893-.726h6.531v-.363a.363.363,0,0,0-.363-.363h-5.8a.363.363,0,0,0-.363.363Z",
    transform: "translate(-33.025 -410.987)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(1.532 12.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(4.875 2.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M161.5,370.732a.363.363,0,0,1-.257-.619l.513-.513a.363.363,0,1,1,.513.513l-.513.513A.362.362,0,0,1,161.5,370.732Z",
    transform: "translate(-161.135 -369.493)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480",
    transform: "translate(3.933 1.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M140.26,345.933a.363.363,0,0,1-.335-.5l.417-1.006a.363.363,0,1,1,.67.278l-.417,1.006A.363.363,0,0,1,140.26,345.933Z",
    transform: "translate(-139.897 -344.201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481",
    transform: "translate(2.822 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M115.21,323.523a.363.363,0,0,1-.363-.363v-1.814a.363.363,0,1,1,.726,0v1.814A.363.363,0,0,1,115.21,323.523Z",
    transform: "translate(-114.847 -320.983)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482",
    transform: "translate(1.434 1.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M84.181,353.158a.363.363,0,0,1-.335-.224l-.277-.67a.363.363,0,1,1,.67-.278l.277.67a.363.363,0,0,1-.335.5Z",
    transform: "translate(-83.541 -351.762)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    transform: "translate(0.878 0.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M71.513,322.585a.363.363,0,0,1-.335-.224l-.139-.335a.363.363,0,1,1,.67-.278l.139.335a.363.363,0,0,1-.335.5Z",
    transform: "translate(-71.012 -321.524)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484",
    transform: "translate(0 1.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M52.336,365.2a.362.362,0,0,1-.257-.106l-.77-.77a.363.363,0,0,1,.513-.513l.77.77a.363.363,0,0,1-.257.619Z",
    transform: "translate(-51.203 -363.708)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4524",
    "data-name": "Group 4524",
    transform: "translate(4.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490",
    transform: "translate(6.882 6.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 1.451,
    height: 3.628,
    transform: "translate(0 1.026) rotate(-45)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487",
    transform: "translate(0.876 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 0.726,
    height: 3.628,
    transform: "translate(0 0.513) rotate(-45)",
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488",
    transform: "translate(0 1.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M264.285,222.27a.362.362,0,0,1-.257-.106l-1.8-1.8a.363.363,0,1,1,.513-.513l1.8,1.8a.363.363,0,0,1-.257.619Z",
    transform: "translate(-262.126 -219.749)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    transform: "translate(1.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M288.2,199.9a.361.361,0,0,1-.257-.106l-2.565-2.565a.363.363,0,0,1,.513-.513l2.565,2.565a.363.363,0,0,1-.257.619Z",
    transform: "translate(-285.274 -196.605)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    transform: "translate(9.492 9.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    transform: "translate(0.362 0.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M335.273,268.212l-4.361-4.361a.726.726,0,0,0-1.026,0l-.513.513a.726.726,0,0,0,0,1.026l4.361,4.361a.726.726,0,0,0,1.026,0l.513-.513A.726.726,0,0,0,335.273,268.212Z",
    transform: "translate(-329.16 -263.638)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(0.575 0.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M339.854,268.212l-4.361-4.361a.726.726,0,0,0-1.026,0l-.513.513a.726.726,0,0,1,1.026,0l4.361,4.361a.726.726,0,0,1,0,1.026l.513-.513A.726.726,0,0,0,339.854,268.212Z",
    transform: "translate(-333.953 -263.638)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(0.362 0.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M334.247,273.818l-4.361-4.361a.725.725,0,0,1,0-1.026l-.513.513a.726.726,0,0,0,0,1.026l4.361,4.361a.726.726,0,0,0,1.026,0l.513-.513A.726.726,0,0,1,334.247,273.818Z",
    transform: "translate(-329.16 -268.431)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    transform: "translate(3.291 1.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M396.074,296.2a.362.362,0,0,1-.257-.106l-.513-.513a.363.363,0,1,1,.513-.513l.513.513a.363.363,0,0,1-.256.619Z",
    transform: "translate(-395.198 -294.963)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M326.436,262.516a1.086,1.086,0,0,1-.77-.318l-4.361-4.361a1.09,1.09,0,0,1,0-1.539l.513-.513a1.09,1.09,0,0,1,1.539,0l.77.77a.363.363,0,0,1-.513.513l-.77-.77a.364.364,0,0,0-.513,0l-.513.513a.363.363,0,0,0,0,.513l4.361,4.361a.363.363,0,0,0,.513,0l.513-.513a.362.362,0,0,0,0-.513l-1.54-1.54a.363.363,0,1,1,.513-.513l1.539,1.539a1.088,1.088,0,0,1,0,1.539l-.513.513A1.086,1.086,0,0,1,326.436,262.516Z",
    transform: "translate(-320.987 -255.466)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502",
    transform: "translate(1.751 4.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742",
    "data-name": "Rectangle 1742",
    width: 1.451,
    height: 4.717,
    transform: "translate(0 1.026) rotate(-45.001)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    transform: "translate(3.185 3.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743",
    "data-name": "Rectangle 1743",
    width: 1.451,
    height: 0.726,
    transform: "translate(0 1.026) rotate(-45)",
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    "data-name": "Rectangle 1744",
    width: 1.451,
    height: 0.726,
    transform: "translate(0 1.026) rotate(-45.001)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500",
    transform: "translate(3.335 3.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M221.993,227.286a.363.363,0,0,1-.257-.619l1.026-1.026a.363.363,0,1,1,.513.513l-1.026,1.026A.361.361,0,0,1,221.993,227.286Z",
    transform: "translate(-221.63 -225.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M146.78,152.072a.363.363,0,0,1-.257-.619l1.026-1.026a.363.363,0,0,1,.513.513l-1.026,1.026A.362.362,0,0,1,146.78,152.072Z",
    transform: "translate(-146.417 -150.32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4508",
    "data-name": "Group 4508",
    transform: "translate(4.83 1.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745",
    "data-name": "Rectangle 1745",
    width: 1.451,
    height: 4.717,
    transform: "translate(0 1.026) rotate(-44.999)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4504",
    "data-name": "Group 4504",
    transform: "translate(3.185 3.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    width: 1.451,
    height: 0.726,
    transform: "translate(0 1.026) rotate(-45.001)",
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4505",
    "data-name": "Group 4505",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    "data-name": "Rectangle 1747",
    width: 1.451,
    height: 0.726,
    transform: "translate(0 1.026) rotate(-44.999)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4506",
    "data-name": "Group 4506",
    transform: "translate(3.335 3.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M291.422,157.857a.363.363,0,0,1-.257-.619l1.026-1.026a.363.363,0,0,1,.513.513l-1.026,1.026A.362.362,0,0,1,291.422,157.857Z",
    transform: "translate(-291.059 -156.105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4507",
    "data-name": "Group 4507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M216.208,82.644a.363.363,0,0,1-.257-.619L216.978,81a.363.363,0,0,1,.513.513l-1.026,1.026A.362.362,0,0,1,216.208,82.644Z",
    transform: "translate(-215.845 -80.892)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4513",
    "data-name": "Group 4513",
    transform: "translate(2.521 2.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4509",
    "data-name": "Group 4509",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 2.903,
    height: 5.442,
    transform: "translate(0 2.052) rotate(-45)",
    fill: "#f4d01e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4510",
    "data-name": "Group 4510",
    transform: "translate(3.441 3.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    "data-name": "Rectangle 1749",
    width: 2.902,
    height: 1.088,
    transform: "translate(0 2.052) rotate(-45)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4511",
    "data-name": "Group 4511",
    transform: "translate(0.363 0.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    "data-name": "Rectangle 1750",
    width: 2.902,
    height: 1.088,
    transform: "translate(0 2.052) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4512",
    "data-name": "Group 4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M167.983,104.877a.362.362,0,0,1-.257-.106l-3.848-3.848a.363.363,0,0,1,0-.513l2.052-2.052a.363.363,0,0,1,.513,0l3.848,3.848a.363.363,0,0,1,0,.513l-2.052,2.052A.362.362,0,0,1,167.983,104.877Zm-3.335-4.211L167.983,104l1.539-1.539-3.335-3.335Z",
    transform: "translate(-163.772 -98.251)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518",
    transform: "translate(0 5.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4514",
    "data-name": "Group 4514",
    transform: "translate(0.062 0.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    d: "M1.088,0h0A1.088,1.088,0,0,1,2.177,1.088V5.079A1.088,1.088,0,0,1,1.088,6.168h0A1.088,1.088,0,0,1,0,5.079V1.088A1.088,1.088,0,0,1,1.088,0Z",
    transform: "translate(0 1.539) rotate(-45)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4515",
    "data-name": "Group 4515",
    transform: "translate(3.14 3.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M180.049,240.272l-.77-.77a.726.726,0,0,1,0,1.026l-.513.513a.725.725,0,0,1-1.026,0l.77.77a.725.725,0,0,0,1.026,0l.513-.513A.726.726,0,0,0,180.049,240.272Z",
    transform: "translate(-177.74 -239.502)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4516",
    "data-name": "Group 4516",
    transform: "translate(0.362 0.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M116.073,178.348l.513-.513a.726.726,0,0,1,1.026,0l-.77-.77a.726.726,0,0,0-1.026,0l-.513.513a.726.726,0,0,0,0,1.026l.77.77A.726.726,0,0,1,116.073,178.348Z",
    transform: "translate(-115.09 -176.853)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4517",
    "data-name": "Group 4517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M111.344,174.706a1.086,1.086,0,0,1-.77-.318l-3.335-3.335a1.09,1.09,0,0,1,0-1.539l.513-.513a1.09,1.09,0,0,1,1.539,0l.77.77a.363.363,0,0,1-.513.513l-.77-.77a.364.364,0,0,0-.513,0l-.513.513a.363.363,0,0,0,0,.513l3.335,3.335a.363.363,0,0,0,.513,0l.513-.513a.363.363,0,0,0,0-.513l-1.8-1.8a.363.363,0,0,1,.513-.513l1.8,1.8a1.088,1.088,0,0,1,0,1.539l-.513.513A1.086,1.086,0,0,1,111.344,174.706Z",
    transform: "translate(-106.921 -168.682)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4523",
    "data-name": "Group 4523",
    transform: "translate(5.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4519",
    "data-name": "Group 4519",
    transform: "translate(0.363 0.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M247.462,53.116l-3.335-3.335a.726.726,0,0,0-1.026,0l-.513.513a.726.726,0,0,0,0,1.026l3.335,3.335a.726.726,0,0,0,1.026,0l.513-.513A.726.726,0,0,0,247.462,53.116Z",
    transform: "translate(-242.375 -49.568)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(3.141 3.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M307.333,112.988l-.77-.77a.726.726,0,0,1,0,1.026l-.513.513a.726.726,0,0,1-1.026,0l.77.77a.726.726,0,0,0,1.026,0l.513-.513A.726.726,0,0,0,307.333,112.988Z",
    transform: "translate(-305.024 -112.218)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4521",
    "data-name": "Group 4521",
    transform: "translate(0.363 0.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M243.357,51.063l.513-.513a.726.726,0,0,1,1.026,0l-.77-.77a.726.726,0,0,0-1.026,0l-.513.513a.726.726,0,0,0,0,1.026l.77.77A.726.726,0,0,1,243.357,51.063Z",
    transform: "translate(-242.375 -49.568)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4522",
    "data-name": "Group 4522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M238.614,47.637a1.085,1.085,0,0,1-.77-.318l-3.335-3.335a1.088,1.088,0,0,1,0-1.539l.513-.513a1.115,1.115,0,0,1,1.539,0l.77.77a.363.363,0,0,1-.513.513l-.77-.77a.372.372,0,0,0-.513,0l-.513.513a.362.362,0,0,0,0,.513l3.335,3.335a.363.363,0,0,0,.513,0l.513-.513a.364.364,0,0,0,0-.513l-1.8-1.8a.363.363,0,1,1,.513-.513l1.8,1.8a1.09,1.09,0,0,1,0,1.539l-.513.513A1.085,1.085,0,0,1,238.614,47.637Z",
    transform: "translate(-234.191 -41.623)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527",
    transform: "translate(0 17.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M26.094,444.441h-9.07a.363.363,0,1,1,0-.725h9.07a.363.363,0,1,1,0,.725Z",
    transform: "translate(-16.661 -443.716)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4526",
    "data-name": "Group 4526",
    transform: "translate(10.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M246.487,444.441h-.363a.363.363,0,1,1,0-.725h.363a.363.363,0,1,1,0,.725Z",
    transform: "translate(-245.761 -443.716)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.06c060b9d27db5bee6a3f3f95bd04b17.svg";
export { ForwardRef as ReactComponent };